
import { useState, useEffect, useRef } from "react";
import shopnavicon1 from '../../../assets/images/bonez_credit_pack5.png'
import back from '../../../assets/images/leave_game_button.png'
import CreateShopModal from './../components/ChipzShop.jsx';
import session from '../../../utils/nakama';



export default function Insufficientcoin(props) {

// const [showShopModal, setShowShopModalimp] = useState(false)
const [showShopModal, setShowShopModal] = useState(false);
const { isCoinActive, toggleCoinContent } = props;


    return (
        <>
                <CreateShopModal
                    showShopModal={showShopModal}
                    setShowShopModal={setShowShopModal}
                    userId={session.user_id}
                />  
            <div style={{ display: 'flex', alignItems: 'center', marginLeft:"-75%" }}>
                <button className="button" style={{ marginLeft: "-2%", marginRight: "-25%" }} onClick={toggleCoinContent}>
                    <img src={back} alt="" width="30%" height="auto" style={{ transform: "rotate(180deg)" }} />
                </button>
                <span className="container-body-text" style={{ fontSize: "20px", color: "#87CEEB", marginTop: "1%", marginLeft: "0" }}>
                    Go Back
                </span>
            </div>


           
            <span className="container-body-text congratulations" style={{ fontSize: "30px", color: "#FFBF00", marginTop: "1%" }}>Not Enough Chipz</span>
            <span className="container-body-text bonezdeck" style={{color: "#FFFFFF", marginTop: "1%" }}>You need at least 10,000</span>
            <span className="container-body-text bonezdeck" style={{color: "#FFFFFF", marginTop: "1%" }}>Chipz to get this.</span>

            <img className="shopicon6" alt="" src={shopnavicon1}/>


            <span className="container-body-text" style={{ fontSize: "30px", color: "#FFFFFF", marginTop: "1%",display: "flex", alignItems: "center", justifyContent: "center"  }}>
                <img
                    className="icon"
                    title="Zoombies Chipz"
                    src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                    style={{ width: "10%", height: "auto", marginRight: "5px", marginBottom: "3px" }}
                    alt="Chipz icon"
                />
                100,000
            </span>
            <span className="container-body-text bonezdeck" style={{color: "#FFBF00", marginTop: "0%" }}>Just USD $0.99</span>

            <button className="button invite" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}  onClick={(e) => setShowShopModal(true)}>
                    <img src="https://zoombies.world/images/dapp/green_button_400.webp" alt="" width="150%" height="auto" />
                    <span className="button-text" style={{ fontSize: "22px" }}>BUY NOW</span>
                </button>


        </>
    )
}